import { render, staticRenderFns } from "./TaskCompletePercent.vue?vue&type=template&id=087a2554&"
import script from "./TaskCompletePercent.vue?vue&type=script&lang=js&"
export * from "./TaskCompletePercent.vue?vue&type=script&lang=js&"
import style0 from "./TaskCompletePercent.vue?vue&type=style&index=0&id=087a2554&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports